import { IOrganisation } from 'app/shared/model/organisation.model';

export interface IDepartment {
  id?: number;
  name?: string | null;
  organisation?: IOrganisation | null;
}

export const defaultValue: Readonly<IDepartment> = {};
